import { minutesToMilliseconds } from "date-fns";

import { GetOrgChartResponseJSON } from "@performyard/service-contracts";

import { PYUseQueryOptions } from "../../../api/hooks/StandardQueryArguments";

import { fetchOrgChart } from "../../../api/services/defs/internal-api";

export const getOrgChartQuery = (options?: PYUseQueryOptions<GetOrgChartResponseJSON>) => ({
	queryKey: ["org-chart"],
	queryFn: fetchOrgChart,
	staleTime: minutesToMilliseconds(5),
	meta: {
		errorMessage: "There was an error getting the org chart.",
	},
	...options,
});
